import { GA_PREFIXES, getCookies, getDomain } from '@/lib/utils'
import { ApplyPreferencesOptions } from '../types/cookieConsentType'

const date = new Date()
date.setFullYear(date.getFullYear() + 100)

export const removeGACookies = () => {
  const cookies = document.cookie
  cookies.split(';').forEach((cookie) => {
    const cookieName = cookie.split('=')[0].trim()
    if (GA_PREFIXES.some((prefix) => cookieName.startsWith(prefix))) {
      document.cookie = `${cookieName}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=${getDomain()}; Secure`
    }
  })
}
export const setThirdPartyCookie = () => {
  document.cookie = `third_party=enabled; Path=/; Expires=${date.toUTCString()}; domain=${getDomain()}; Secure`
}
export const unSetThirdPartyCookie = () => {
  document.cookie = `third_party=disabled; Path=/; Expires=${date.toUTCString()}; domain=${getDomain()}; Secure`
}
export const setBasicCookies = () => {
  document.cookie = `basic_cookie=enabled; Path=/; Expires=${date.toUTCString()}; domain=${getDomain()}; Secure`
}

export const setCaptchaCookie = () => {
  document.cookie = `captcha=enabled; Path=/; Expires=${date.toUTCString()}; domain=${getDomain()}; Secure`
}
export const unSetCaptchaCookie = () => {
  document.cookie = `captcha=disabled; Path=/; Expires=${date.toUTCString()}; domain=${getDomain()}; Secure`
}
export const unSetReCaptchaCookies = () => {
  document.cookie = `recaptcha=; Path=/; Expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=${getDomain()}; Secure`
}

export const STATISTICS_COOKIES_DETAILS = [
  {
    name: '_ga',
    description:
      'Used by Google Analytics to distinguish unique users by assigning a randomly generated number as a client identifier.',
    duration: '6 Months',
    type: 'HTTP Cookie',
  },

  {
    name: 'third_party',
    description:
      'Controls preferences for third-party tracking and analytics services.',
    duration: '6 Months',
    type: 'HTTP Cookie',
  },
]
export const HCAPTCHA_COOKIES_DETAILS = [
  {
    name: 'captcha',
    description: 'Used to control preferences for CAPTCHA services.',
    duration: '6 Months',
    type: 'HTTP Cookie',
  },
  {
    name: '__cf_bm',
    description: 'CLOUDFLARE_HCAPTCHA_COOKIE_DESCRIPTION',
    duration: '6 Months',
    type: 'HTTP Cookie',
  },
]
export const RECAPTCHA_COOKIES_DETAILS = [
  {
    name: '_GRECAPTCHA',
    description:
      'Used by Google reCAPTCHA to provide spam protection and distinguish between humans and bots.',
    duration: '6 Months',
    type: 'HTTP Cookie',
  },
  {
    name: 'captcha',
    description: 'Used to control preferences for CAPTCHA services.',
    duration: '6 Months',
    type: 'HTTP Cookie',
  },
]

export const COOKIES_LIST_ITEMS = [
  {
    hostname: '.fructidor.com',
    category: 'Necessary',
    name: '_fructidor_api_session_production',
    secure: 'No',
    httpOnly: 'Yes',
    thirdParty: 'No',
    type: 'Cookie',
    expiry: 'Session',
  },
  {
    hostname: '.fructidor.com',
    category: 'Analytics',
    name: '_ga',
    secure: 'No',
    httpOnly: 'No',
    thirdParty: 'No',
    type: 'Cookie',
    expiry: '6 Months',
  },
  {
    hostname: '.fructidor.com',
    category: 'Analytics',
    name: '_ga_*',
    secure: 'No',
    httpOnly: 'No',
    thirdParty: 'No',
    type: 'Cookie',
    expiry: '6 Months',
  },
  {
    hostname: '.fructidor.com',
    category: 'Necessary',
    name: 'basic_cookie',
    secure: 'Yes',
    httpOnly: 'No',
    thirdParty: 'No',
    type: 'Cookie',
    expiry: '6 Months',
  },
  {
    hostname: 'fructidor.com',
    category: 'tracking',
    name: 'fructidor_uid',
    secure: 'No',
    httpOnly: 'Yes',
    thirdParty: 'No',
    type: 'Cookie',
    expiry: 'Session',
  },
  {
    hostname: 'fructidor.com',
    category: 'Necessary',
    name: 'lang',
    secure: 'No',
    httpOnly: 'Yes',
    thirdParty: 'No',
    type: 'Cookie',
    expiry: 'Session',
  },
  {
    hostname: '.fructidor.com',
    category: 'preferences',
    name: 'third_party',
    secure: 'Yes',
    httpOnly: 'No',
    thirdParty: 'Yes',
    type: 'Cookie',
    expiry: '6 Months',
  },
]

export const RECAPTCHA_LIST_ITEMS = [
  {
    hostname: 'www.google.com',
    category: 'security',
    name: '_GRECAPTCHA',
    secure: 'Yes',
    httpOnly: 'No',
    thirdParty: 'Yes',
    type: 'Cookie',
    expiry: '6 Months',
  },
  {
    hostname: '.fructidor.com',
    category: 'security',
    name: 'recaptcha',
    secure: 'Yes',
    httpOnly: 'No',
    thirdParty: 'No',
    type: 'Cookie',
    expiry: '6 Months',
  },
]

export const HCAPTCHA_LIST_ITEMS = [
  {
    hostname: '.hcaptcha.com',
    category: 'security',
    name: '__cf_bm',
    secure: 'Yes',
    httpOnly: 'No',
    thirdParty: 'Yes',
    type: 'Cookie',
    expiry: '30 Minutes',
  },
  {
    hostname: '.fructidor.com',
    category: 'security',
    name: 'captcha',
    secure: 'Yes',
    httpOnly: 'No',
    thirdParty: 'No',
    type: 'Cookie',
    expiry: '6 Months',
  },
]

export const HCAPTCHA_DESCRIPTION = 'HCAPTCHA_DESCRIPTION'

export const RECAPTCHA_DESCRIPTION = 'RECAPTCHA_DESCRIPTION'

export const cookieCaptchaEnabled = (): boolean => {
  const cookies = getCookies()
  const isCaptchaEnabledByCookie = cookies?.captcha === 'enabled'
  return isCaptchaEnabledByCookie
}

// Note: Be carefull while altering this Function
//       It may break cookie consent setup
export const applyPreferences = ({
  actualValue,
  storedCookie,
  cleanupFunction,
  setterFunction,
  unSetterFunction,
}: ApplyPreferencesOptions) => {
  if (actualValue && storedCookie === 'enabled') {
  } else if (!actualValue && storedCookie === 'disabled') {
    cleanupFunction()
  } else if (!actualValue && storedCookie === 'enabled') {
    unSetterFunction()
    return { shouldReload: true }
  } else if (actualValue && storedCookie === 'disabled') {
    setterFunction()
    return { shouldReload: true }
  } else if (storedCookie == undefined && actualValue) {
    setterFunction()
    return { shouldReload: true }
  } else if (storedCookie == undefined && !actualValue) {
    unSetterFunction()
    return { shouldReload: true }
  }
  return { shouldReload: false }
}
